import { Modal, Input } from "antd";
import { useSlateStatic } from "slate-react";
import { Transforms } from "slate";
import { useState } from "react";
import { insertEmbedFromUrl } from "packages/richText/utils/autoEmbed";
import KoIcon from '@kwapio/icons';
import KoButton from "packages/button";

export const InsertEmbedButton = ({ editor, disabled }) => {

  const insertEmbed = (url) => {
    const paragraph = { type: "paragraph", children: [{ text: "" }] };
    const embedNode = {
      type: "embed",
      url,
      width: "100%",
      height: 300,
      align: "left",
      children: [{ text: "" }]
    };

    // ✅ Insert paragraph before, then embed, then paragraph after
    Transforms.insertNodes(editor, paragraph);          // before
    Transforms.insertNodes(editor, embedNode);
    Transforms.insertNodes(editor, paragraph);          // after
  };

  return (
    <EmbedInputButton
      icon="GlobeOutlined"
      disabled={disabled}
      label="Embed URL"
      placeholder="https://example.com/embed"
      onInsert={insertEmbed}
    />
  );
};

const EmbedInputButton = ({ icon, label, placeholder, onInsert, disabled }) => {
  const [visible, setVisible] = useState(false);
  const [url, setUrl] = useState("");
  const editor = useSlateStatic();

  return (
    <>
      <KoButton
        type="text"
        disabled={disabled}
        iconBtn
        icon={<KoIcon width={20} height={20} name={icon} />}
        onClick={() => setVisible(true)}
        title={`Insert ${label}`}
      />
      <Modal
        title={`Insert ${label}`}
        open={visible}
        centered
        onCancel={() => setVisible(false)}
        onOk={async() => {
          const handled = await insertEmbedFromUrl(editor, url);
          if (!handled) {
            onInsert(url); // fallback if not handled by autoEmbed
          }
          setVisible(false);
          setUrl("");
        }}
        okText="Insert"
      >
        <Input
          value={url}
          placeholder={placeholder}
          onChange={(e) => setUrl(e.target.value)}
          allowClear={false} // ✅ Remove link-style clear icon
        />
      </Modal>
    </>
  );
};
